import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

import PropTypes from 'prop-types';
import { sessionSelector } from '../selectors';

const routePolicies = [{ route: '/admin', policy: 'admin' }];

class PrivateRoute extends Component {
	redirectTo(to) {
		return <Redirect to={{ pathname: to }} />;
	}

	redirectToLogin(path, redirect = true) {
		if (redirect) {
			localStorage.setItem('returnFromLogin', path);
		}

		return this.redirectTo('/login');
	}

	routeRender(props, Component, session, location) {
		const { authenticated, loggedOut } = session;
		
		const { pathname } = location;

		if (loggedOut) {
			return this.redirectToLogin(pathname, false);
		}

		if (!authenticated) {
			return this.redirectToLogin(pathname);
		}

		if (pathname === '/' && session.hasPolicy('admin')) {
			return this.redirectTo('/admin');
		}

		const routePolicy = routePolicies.find(routePolicy => routePolicy.route === pathname);

		if (routePolicy && !session.hasPolicy(routePolicy.policy)) {
			return this.redirectTo('/unauthorized');
		}

		return <Component {...props} />;
	}

	render() {
		const { session, component: Component, location, ...rest } = this.props;
		return <Route {...rest} location={location} render={props => this.routeRender(props, Component, session, location)} />;
	}
}

PrivateRoute.propTypes = {
	component: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

const mapStateToProps = state => {
	return {
		session: sessionSelector(state)
	};
};

const mapDispatchToProps = () => ({
	actions: {}
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
